import { lazy } from "react";
import { Platform } from "react-native";
import { tabsDataType } from "@components/common/types";
import Routes from "@navigations/Routes";

// Platform-conditional imports: lazy on web, direct on mobile
const MoreNavigator =
  Platform.OS === "web"
    ? lazy(() => import("@navigations/more-navigator"))
    : require("@navigations/more-navigator").default;

const ExploreNavigator =
  Platform.OS === "web"
    ? lazy(() => import("@navigations/explore-navigator"))
    : require("@navigations/explore-navigator").default;

const RequestHistoryNavigator =
  Platform.OS === "web"
    ? lazy(() => import("../request-history-navigator"))
    : require("../request-history-navigator").default;

const HomeNavigator =
  Platform.OS === "web"
    ? lazy(() => import("@navigations/home-navigator"))
    : require("@navigations/home-navigator").default;

const FavoritesNavigator =
  Platform.OS === "web"
    ? lazy(() => import("@navigations/favorite-navigator"))
    : require("@navigations/favorite-navigator").default;

const PagesNavigator =
  Platform.OS === "web"
    ? lazy(() => import("@navigations/pages-navigator"))
    : require("@navigations/pages-navigator").default;

const FilterScreen =
  Platform.OS === "web"
    ? lazy(() => import("@scenes/explore/FilterScreen"))
    : require("@scenes/explore/FilterScreen").default;

const SavedSearch =
  Platform.OS === "web"
    ? lazy(() => import("@components/molecules/SavedSearchTab/SavedSearch"))
    : require("@components/molecules/SavedSearchTab/SavedSearch").default;

const FilterSplitScreen =
  Platform.OS === "web"
    ? lazy(() => import("@scenes/explore/FilterSplitScreen"))
    : require("@scenes/explore/FilterSplitScreen").default;

// Map of component names to their respective files
export const componentMap = {
  HomeNavigator,
  PagesNavigator,
  FavoritesNavigator,
  ExploreNavigator,
  RequestHistoryNavigator,
  MoreNavigator,
  FilterScreen,
  SavedSearch,
  FilterSplitScreen,
};

// Function to convert tabsData to include component files
export function convertTabsData(tabsData: tabsDataType[]) {
  return tabsData.map((tab) => ({
    ...tab,
    name: Routes[tab?.component] || Routes.HomeNavigator,
    component: componentMap[tab?.component] || HomeNavigator,
  }));
}

export const findDefaultScreenTab = (tabsData: any[]) => {
  const fallbackTabName = Routes.ExploreNavigator;
  if (!tabsData || !Array.isArray(tabsData)) return fallbackTabName;

  const defaultTab = tabsData?.find((tab) => tab?.is_default_screen === true);

  return defaultTab?.name ?? fallbackTabName;
};

export const getDefaultScreenConfig = (tabsData: any[]) => {
  if (!tabsData || !Array.isArray(tabsData) || tabsData.length === 0) {
    return {};
  }

  const defaultTab = tabsData.find((tab) => tab?.is_default_screen === true);

  if (defaultTab) {
    return defaultTab;
  }
  const firstProductTab = tabsData.find((tab) => tab?.isProduct === true);

  return firstProductTab || {};
};
